'use strict';
import * as $j_app$002eapi$002e$002dUnauthenticated$002dApp$002dUpdate from "./app.api.-Unauthenticated-App-Update.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_UnauthenticatedAppUpdate$Initialize(serverInProductionMode) {
  this.Lapp_api_UnauthenticatedAppUpdate$Initialize__f_serverInProductionMode = false;
  this.Lapp_api_UnauthenticatedAppUpdate$Initialize__f_serverInProductionMode = serverInProductionMode;
}
export { $c_Lapp_api_UnauthenticatedAppUpdate$Initialize as $c_Lapp_api_UnauthenticatedAppUpdate$Initialize };
$c_Lapp_api_UnauthenticatedAppUpdate$Initialize.prototype = new $j_app$002eapi$002e$002dUnauthenticated$002dApp$002dUpdate.$h_Lapp_api_UnauthenticatedAppUpdate();
$c_Lapp_api_UnauthenticatedAppUpdate$Initialize.prototype.constructor = $c_Lapp_api_UnauthenticatedAppUpdate$Initialize;
/** @constructor */
function $h_Lapp_api_UnauthenticatedAppUpdate$Initialize() {
}
export { $h_Lapp_api_UnauthenticatedAppUpdate$Initialize as $h_Lapp_api_UnauthenticatedAppUpdate$Initialize };
$h_Lapp_api_UnauthenticatedAppUpdate$Initialize.prototype = $c_Lapp_api_UnauthenticatedAppUpdate$Initialize.prototype;
$c_Lapp_api_UnauthenticatedAppUpdate$Initialize.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-809363444), true);
});
$c_Lapp_api_UnauthenticatedAppUpdate$Initialize.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_api_UnauthenticatedAppUpdate$Initialize) && (this.Lapp_api_UnauthenticatedAppUpdate$Initialize__f_serverInProductionMode === x$0.Lapp_api_UnauthenticatedAppUpdate$Initialize__f_serverInProductionMode)));
});
$c_Lapp_api_UnauthenticatedAppUpdate$Initialize.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_UnauthenticatedAppUpdate$Initialize.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_api_UnauthenticatedAppUpdate$Initialize.prototype.productPrefix__T = (function() {
  return "Initialize";
});
$c_Lapp_api_UnauthenticatedAppUpdate$Initialize.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_UnauthenticatedAppUpdate$Initialize__f_serverInProductionMode;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_UnauthenticatedAppUpdate$Initialize.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "serverInProductionMode";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_UnauthenticatedAppUpdate$Initialize.prototype.ordinal__I = (function() {
  return 1;
});
function $isArrayOf_Lapp_api_UnauthenticatedAppUpdate$Initialize(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_UnauthenticatedAppUpdate$Initialize)));
}
export { $isArrayOf_Lapp_api_UnauthenticatedAppUpdate$Initialize as $isArrayOf_Lapp_api_UnauthenticatedAppUpdate$Initialize };
var $d_Lapp_api_UnauthenticatedAppUpdate$Initialize = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_UnauthenticatedAppUpdate$Initialize, "app.api.UnauthenticatedAppUpdate$Initialize", ({
  Lapp_api_UnauthenticatedAppUpdate$Initialize: 1,
  Lapp_api_UnauthenticatedAppUpdate: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_api_UnauthenticatedAppUpdate$Initialize as $d_Lapp_api_UnauthenticatedAppUpdate$Initialize };
//# sourceMappingURL=app.api.-Unauthenticated-App-Update$-Initialize.js.map
